module.exports = __webpack_public_path__ + "static/venmo-d795deddcc4d7ea98a02164a116c57e7.jpg";